import { render, staticRenderFns } from "./news-content.vue?vue&type=template&id=5daf1b43&scoped=true"
import script from "./news-content.vue?vue&type=script&lang=js"
export * from "./news-content.vue?vue&type=script&lang=js"
import style0 from "./news-content.vue?vue&type=style&index=0&id=5daf1b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf1b43",
  null
  
)

export default component.exports